<template>
<div>
  <div
    class="contentblock board_layout"
    :data-block-id="bdata.paperBlockId"
  >
    <ContentBlockCreatorInfo
      :bdata ="bdata"
      :blockModDate="blockModDate"
      :blockRegDate="blockRegDate"
      :blockModUserName="blockModUserName"
      :blockRegUserName="blockRegUserName">
    </ContentBlockCreatorInfo>
    <div class="eidtbox-ty1 attachfile_box">
      <div class="row_box clear hover_box">
        <!-- [rowbox] -->
        <div class="hover_inner">
          <!-- [드래그 핸들] -->
          <!-- 보이는 드래그 핸들 -->
          <div class="move"></div>
          <!-- 실제 이벤트 드래그 핸들 -->
          <div class="block_handle" ref="dragHandle"
            :data-block-id="bdata.paperBlockId"
            :transfer-data="bdata.paperBlockId"
            @mousedown="dragBlockState(1)"
            @mouseup="dragBlockState(0)"
            @touchstart="dragBlockState(1)"
            @touchend="dragBlockState(0)">
            &nbsp;
          </div>
          <!-- /[드래그 핸들] -->
          <div class="file_row clear">
            <!-- [파일타입 블럭] -->
            <div class="file_name ell-singleline"
              :class="'ico-file-' + iconType()">
              <span @click="callFileViewer"> {{ bdata.contentPath }} </span>
            </div>
            <div class="file-lock block-contentfile" :style="fileLockYn ? '':'display:none;'"></div>
            <div class="btn">
              <div class="droplayer icon more large right nosel">
                 <v-menu bottom left @input="onMenuToggle">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="permit_everyone" v-bind="attrs" v-on="on" @click="checkStatus(attrs)">{{$i18nUtil.trans("button.more","더보기")}}</v-btn>
                  </template>
                  <div class="dropdown-list">
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <button
                          type="button"
                          @click="downloadFile"
                        >
                          {{$i18nUtil.trans("button.file.download","다운로드")}}
                        </button>
                      </div>
                    </div>
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <button
                          type="button"
                          @click="confirmReplaceFile" :disabled="fileBtnDisabledYn"
                        >
                          {{$i18nUtil.trans("message.ContentBlockTypeFile.001","파일 교체")}}
                        </button>
                      </div>
                    </div>
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <button
                          type="button"
                          @click="copyURL"
                        >
                          {{$i18nUtil.trans("button.url.copy","URL 복사")}}
                        </button>
                      </div>
                    </div>
                    <div class="dropdown-list-item">
                      <div class="tit">
                        <button
                          type="button"
                          @click="deleteFileBlock" :disabled="fileBtnDisabledYn"
                        >
                          {{$i18nUtil.trans("button.file.delete","파일 삭제")}}
                        </button>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
            </div>
            <!-- <div class="btn" :data-block-id="bdata.paperBlockId" v-if="bdata.blockState && fileCancleYn " style="
    margin-right: -70px; padding-right: 5px; 
" ><button @click="stopUploadFile">{{$i18nUtil.trans("button.cancel","취소")}}</button></div> -->
            <!-- /[파일타입 블럭] -->
          </div>
          
          <!-- [의견 영역] -->
          <div
            v-if="!bdata.blockState"
            ref="buttonComment"
            class="hover_comment"
            :class="
            (commentCount ? ' display-block' : '') +
            (blockInfo.commentSelectId === bdata.paperBlockId ? ' display-block active' : '')
            "
            >
            <button type="button" class="permit_everyone" @click="viewComment">
              {{ !commentCount ? "" : commentCount }}
            </button>
          </div>
          <!-- /[의견 영역] -->
        </div>
        <!-- /[rowbox] -->
        <div v-if="bdata.blockState" class="loading-box white">
          <div v-if="!searhFileInfo" class="loader_wrap">
            <div class="loader">{{$i18nUtil.trans("message.ContentBlockTypeFile.002","파일 업로드 중입니다.")}}</div>
            <div class="loader-txt">{{$i18nUtil.trans("message.ContentBlockTypeFile.002","파일 업로드 중입니다.")}}</div>
          </div>
          <div v-if="searhFileInfo" class="loader_wrap">
            <div class="loader">{{$i18nUtil.trans("message.ContentBlockTypeFile.006","파일 조회 중입니다.")}}</div>
            <div class="loader-txt">{{$i18nUtil.trans("message.ContentBlockTypeFile.006","파일 조회 중입니다.")}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="hidden">
    <input ref="replaceFilePick" type="file" @change="pickupReplaceFile"/>
  </div>
</div>
</template>
<script>
import axios from "axios";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import ProgressCircle from "../extensions/ProgressCircle";
import ContentBlockCreatorInfo from "./ContentBlockCreatorInfo";

export default {
  components: {
    Datepicker,
    ProgressCircle,
    ContentBlockCreatorInfo,
  },
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    memberSelector: Object,
  },
  data() {
    return {
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      loading: true,
      messageList: [],
      files: [],
      fileUploadType: null,
      state: {
      },
      userList: [],
      commentCount: this.blockInfo.commentCounts[this.bdata.paperBlockId],
      opinionEditorData: {
        deciName: null,
        paperId: String(this.paperInfo.paperId),
        contents: null,
        paperFileId: null,
        userId: null,
        fileName: null
      },
      members: this.boardMemberInfo.userList,
      opinionUpfile: {
        groupId: String(this.paperInfo.groupId),
        paperId: String(this.paperInfo.paperId),
        files: []
      },
      opiniondata: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null
      },
      files: [],
      udfform: {
        paperFileId: "",
        seq: "",
        fileId: "",
        fileName: ""
      },
      opiTargetName: this.$i18nUtil.trans("message.ContentBlockTypeDecision.004","결정자 선택"),

      blockModDate : '',
      blockRegDate: '',
      blockModUserName:'',
      blockRegUserName:'',
      fileCancleYn: false,
      fileUploadCancleType: null,
      timeOutEvent: null,
      loginUserId: localStorage.getItem("userId"),
      
      searhFileInfo: false,
      fileBtnDisabledYn : true,
      fileLockYn: false,
      /* 20230627 추가 */
      tenantId: localStorage.getItem("tenantId")
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
    // if(this.pdata.blockState == 1) {
    //   // 블록 생성하자마자 1일경우 2분체크
    //   this.timeOutEvent = setTimeout(() => {
    //       // 취소버튼 생성
    //       this.fileCancleYn = true;
    //   },100) // 2분
    // }
  },
  mounted() {
    let self = this;
    this.transmitter.subscribers[self.bdata.paperBlockId] = {
      subscribe: function(command, data, error) {
        self.stompEditorSubscribe(command, data, error);
      }
    };
    this.onConnected();
    this.renderCompleted(function(){
      self.$emit("blockMatch");
    });
  },
  computed:{
    ...mapState("noti", ["notiBoardBlockId"]),
  },
  updated() { },
  beforeDestroy() {
    delete this.transmitter.subscribers[this.bdata.paperBlockId];
  },
  watch: {
    // "pdata.blockState"(payload) { 
    //   console.log("파일블럭 생성시작: " + this.pdata.blockState)
    //   // 이떄는 payload가 1일때 셋타임아웃 걸고 0으로 다시바뀌면 셋타임아웃 취소 
    //   if(payload == 1) {
    //     this.timeOutEvent = setTimeout(() => {
    //       // 취소버튼 생성
    //     this.fileCancleYn = true;
    //     },1000) // 2분
    //   } else {
    //     // 0으로 된거 감지 될경우
    //     if(this.timeOutEvent) {
    //       clearTimeout(this.timeOutEvent);
    //       this.timeOutEvent = null;
    //       this.$emit("close");
    //     }
    //   }
    //   //console.log("파일블럭 생성시작 111: " + this.fileCancleBtn)
    //   this.fileCancleYn = false;
    //   },
    "pdata.fileId"() {
      
     },
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    stompEditorSubscribe(command, bdata, error) {
      let updateToken = null;
      if (command === "content") {
        if (bdata.paperId === this.paperInfo.paperId &&
          bdata.paperBlockId === this.bdata.paperBlockId) {
          let toastMsg = "";
          
          // 파일 정상적 업로드시 블럭 수정자/수정시간 변경.
          if(!error.code && error.message == "UPLOAD_SUCCESS"){
            if(bdata.modDate != null){
              this.blockModDate = bdata.modDate;
              this.blockModUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.modUserNameEn !== null ? bdata.modUserNameEn : bdata.modUserName;
            }
            if(bdata.regDate != null){
              this.blockRegDate = bdata.regDate;
              this.blockRegUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.regUserNameEn !== null ? bdata.regUserNameEn : bdata.regUserName;
            }
          }

          if (this.bdata.regUserId === this.userInfo.userId &&
            !error.code && error.message == "UPLOAD_SUCCESS") {
            toastMsg = this.$i18nUtil.trans("message.OutputBoard.003","파일이 정상적으로 업로드 되었습니다.");
          } else if (this.bdata.regUserId === this.userInfo.userId &&
            error.code && error.message == "COFILE_FILE_REPLACE_FAIL") {
            toastMsg = this.$i18nUtil.trans("TB103"); // 파일 교체가 실패하였습니다.
          } else if (this.bdata.regUserId === this.userInfo.userId &&
            error.code && error.message == "COFILE_FILE_UPLOAD_DISALLOW_BY_CDR") {
            toastMsg = this.$i18nUtil.trans("TB104"); // 파일 정보 이상으로 업로드가 차단되었습니다.
          }
          if (toastMsg) {
            this.toast(toastMsg);
          }
          updateToken = bdata.updateToken;
          if (updateToken && this.boardUtil.findUpdateToken(updateToken) != -1) {
            /* 전파자가 보낸신호는 되받지 않음 */
            this.boardUtil.removeUpdateToken(updateToken);
            return true;
          }

          // 파일교체시 오류가 발생한경우 bdata의 fileId,blockstate 등 정보가 없음. (10.27 : 조성기)
          // console.log(bdata.fileId + " / "+ bdata.content + " / "+bdata.blockState);
          if(bdata.fileId != null && bdata.fileId != 'undefined'){
            this.bdata.contentPath = bdata.content;
            this.bdata.blockState = Number(bdata.blockState);
            this.bdata.fileId = bdata.fileId;
          }
        }
        return true;
      }
      return false;
    },
    /* synap 파일 뷰어 호출 */
    callFileViewer(e) {
      // let link = document.createElement("a");
      // link.setAttribute("href", this.getFileUrl(true));
      // link.setAttribute("target", "_blank");
      // link.click();
      // this.$router.push( this.getFileUrl(true));

      // 파일뷰어에서 window.close() 시, 크롬에서 작동하게 하기 위해 window.open 처리
      window.open(this.getFileUrl(true));
    },
    downloadFile(e) {
      this.context.downloadFile(this, e);
    },
    copyClipboard(e) {
      this.boardUtil.copyClipboard(this.getFileUrl());
    },
    deleteFileBlock(e) {
      let self = this;
      /* 권한체크 RW = permission 2 */
      if (self.paperInfo.permission > 1) {
        self.deleteModal(self.$i18nUtil.trans("AG001"), (modal) => {
          modal.close();
          self.deleteBlock({ callback(res) {
            if(res.data.errorCode != null){
              if(res.data.result.LockType == "LOCKED"){
                self.fileBtnDisabledYn = true;
                self.fileLockYn = true;
              }
            }else{
              if (res && res.data && !res.data.errorCode) {
                self.boardUtil.removeBlockData(self.bdata.paperBlockId);
                let toastMsg = self.$i18nUtil.trans("TB011");
                self.toast(toastMsg);
              }
            }
          }});
        });
      }
      else {
        /* 권한이 없습니다 */
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    opinionCreate() {
      /* 의사결정 위젯을 띄운다 */
      let el = this.$refs.opinionForm;
      el.classList.toggle("hidden");
      console.log("show opinion create form");
    },
    confirmReplaceFile() {
      let self = this;
      // ConfirmModal - 파일 교체 시 파일 내 활동한 이력은 유지되며 파일명만 교체됩니다. 교체하시겠습니까?
      if (self.paperInfo.permission > 1) {
        self.showConfirmDialog(
          { width : "400px" },
          self.$i18nUtil.trans("title.Noti.001","알림"),
          self.$i18nUtil.trans("AB017"),
          self.$i18nUtil.trans("message.ContentBlockTypeFile.003","교체"),
          self.clickReplaceFilePick,
          null,
          self.$i18nUtil.trans("button.cancel","취소"),
          null,
          "replaceFile"
        );
      }
      else {
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    iconType() {
      let fileName = this.bdata.contentPath;
      let type = this.boardUtil.fileExt(fileName);
      let ext = "etc";
      if (type[0] && type[0].length >= 3) {
        ext = type[0].substring(0, 3);
        if (ext === "ppt" || ext === "zip" || ext === "hwp" || ext === "pdf" || ext === "zip") {
          // NO-OP
        }
        else if (ext === "doc") {
          ext = "word";
        }
        else if (ext === "xls") {
          ext = "xlsx";
        }
        else {
          ext = "etc";
        }
      }
      return ext;
    },
    clickReplaceFilePick() {
      let self = this;
      self.$refs.replaceFilePick.click();
    },
    pickupReplaceFile(e) {
      let self = this;
      let util = self.boardUtil;
      let fileElem = self.$dm(self.$refs.replaceFilePick);
      if (fileElem.files.length) {
        let fncHideProgress = function () {
          if (fileElem) { fileElem.value = null; }
          // setTimeout(self.context.hideProgress, 1000);
          self.context.hideProgress();
        };
        this.bdata.blockState = 1;
        this.updateFileBlock();
        let formData = new FormData();
        let header = {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("Authorization"),
        };
        //self.context.showProgress(60000);

        formData.append("file", fileElem.files[0]);
        formData.append("fileId", self.bdata.fileId);
        formData.append("paperBlockId", self.bdata.paperBlockId);
        formData.append("sharepointSiteId", String(self.paperInfo.sharepointSiteId));
        formData.append("sharepointFolderId", String(self.paperInfo.sharepointFolderId));
        axios
          .post("/api/cofile/paper/replaceFile", formData, header)
          .then((res) => {
            fncHideProgress();
            if (util.hasSub(res, ["data", "result"])) {
              if(res.data.result.LockType == "LOCKED"){
                self.bdata.blockState = 0;
                self.updateFileBlock();
                self.fileBtnDisabledYn = true;
                self.fileLockYn = true;
              }else{
                let fileInfo = res.data.result.fileInfo;
                // console.log("FILE-INFO:", fileInfo);
              }
            } else {
              if(util.hasSub(res, ["data", "errorCode"])) {
                /* 오류 발생시 락 해제부터 수행한다 */
                self.bdata.blockState = 0;
                self.updateFileBlock();
                let errorCode = res.data.errorCode;
                if(errorCode === "COFILE_FILE_REPLACE_FAIL") { // 파일 교체 실패
                  self.showAlertDialog(self.$i18nUtil.trans("AB070"));
                  return;
                } else if (errorCode === "COFILE_FILE_EXT_NOT_MATCH") { // 확장자 불일치
                  self.showAlertDialog(self.$i18nUtil.trans("AB036"));
                  return;
                } else if (errorCode === "COFILE_STORAGE_CAPACITY_EXCEEDED") { // 용량 부족
                  self.showAlertDialog(self.$i18nUtil.trans("AB054", { groupKbn: res.data.errorMessage }));
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") { // 용량 부족
                  self.showAlertDialog(self.$i18nUtil.trans("AB108",{ limitSize: res.data.errorMessage /1024 /1024 }));
                  return;
                }else if (errorCode === "COFILE_DLP_ERROR") { // DLP 개인정보 필터링 차단
                  /*let errorMessage = JSON.parse(res.data.errorMessage);
                  let message = errorMessage.detectedMessage;
                  let modalHeight = 180;

                  if (errorMessage.detectedFiles.length > 0) {
                    let detectedFiles = errorMessage.detectedFiles;
                    if (detectedFiles[0].data.length > 0) {
                      let detectedFilesData = detectedFiles[0].data;
                      for (let i = 0; i < detectedFilesData.length; i++) {
                        message += "\n";
                        message += "\n- 분 류 : " + detectedFilesData[i].pattern + " ( " + detectedFilesData[i].count + " 건 ) ";
                        message += "\n- 내 용 : " + detectedFilesData[i].content;
                        modalHeight += 60;
                      }
                    }
                  }

                  modalHeight = modalHeight + "px";
                  this.showAlertDialog(message, null, {
                    width: "600px",
                    height: modalHeight,
                  });*/
                  
                  // 2023-06-20 검출 건수 표시 및 공통 함수로 처리
                  //self.showAlertDialog(self.$i18nUtil.trans("AB076"));
                  util.makeDLPErrorMsg(self, res.data.errorMessage);
                  return;
                } else if (errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL") { // 외부망에서 업로드 불가
                  self.showAlertDialog(self.$i18nUtil.trans("AB100"));
                  return;
                }
              }
            }
          })
          .catch(function (err) {
            fncHideProgress();
            self.bdata.blockState = 0;
            self.fileCancleYn = false;
            self.updateFileBlock();
            console.log("파일 업로드 실패");
            console.log(err);
          });
      }
    },
    noticeDownloadFail(){
      this.showAlertDialog(this.$i18nUtil.trans("AB077"));
    },
    noticeDownloadFailFromExternal() {
      this.showAlertDialog(this.$i18nUtil.trans("AB101"));
    },
    notAuthorizedDownloadFail(){
      let toastMsg = this.$i18nUtil.trans("TB044");
      this.toast(toastMsg);
    },
    copyURL() {
      this.boardUtil.copyClipboard(this.getFileUrl());
      let toastMsg = this.$i18nUtil.trans("TB010");
      this.toast(toastMsg);
    },
    uploadCancel(){
      
      // let self = this;
      // console.log("bdata : ", self.bdata)
      // let fileElem = self.$dm(self.$refs.replaceFilePick);
      // if (fileElem.files.length) {
      //   let fncHideProgress = function () {
      //     if (fileElem) { fileElem.value = null; }
      //     // setTimeout(self.context.hideProgress, 1000);
      //     self.context.hideProgress();
      //   };
      //   this.bdata.blockState = 1;
      //   this.updateFileBlock();
      //   let formData = new FormData();
      //   let header = {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: localStorage.getItem("Authorization"),
      //   };
      //   //self.context.showProgress(60000);
      //   formData.append("file", fileElem.files[0]);
      //   formData.append("fileId", self.bdata.fileId);
      //   formData.append("paperId", self.bdata.paperId);
      //   formData.append("paperBlockId", self.bdata.paperBlockId);
      //   formData.append("oldFileName", self.bdata.contentPath);
      //   axios
      //     .post("/api/cofile/paper/replaceFileCancel", formData, header)
      //     .then((res) => {
      //       fncHideProgress();
      //       self.bdata.blockState = 0;
      //       self.fileCancleYn = false;
      //       self.updateFileBlock();
      //       console.log("파일 교체 취소");
      //       console.log(err);
      //     })
      //     .catch(function (err) {
      //       fncHideProgress();
      //       self.bdata.blockState = 0;
      //       self.fileCancleYn = false;
      //       self.updateFileBlock();
      //       console.log("파일 교체 취소 실패");
      //       console.log(err);
      //     });
      // }
      this.bdata.blockState = 0;
      this.fileCancleYn = false;
      this.updateFileBlock();
      console.log("파일 교체 취소");
    },
    stopUploadFile(){
      if(!this.bdata.fileId){
        console.log("파일삭제");
        this.deleteFileBlock();
      }else{
        console.log("파일교체알림");
        this.showConfirmDialog(
          { width : "400px" },
          this.$i18nUtil.trans("title.Noti.001","알림"),
          this.$i18nUtil.trans("AB111"),
          this.$i18nUtil.trans("message.ContentBlockTypeFile.004","교체취소"),
          this.uploadCancel,
          null,
          this.$i18nUtil.trans("button.cancel","취소"),
          null
        );
      }
    },
    checkStatus(attrs){
      // 더보기창 열렸을때 . 
      if(attrs["aria-expanded"] == "false"){
        let obj = this;
        obj.searhFileInfo = true;
        obj.bdata.blockState = 1;
        obj.fileBtnDisabledYn = true;
        obj.fileLockYn = false;
        let reqData = {
          url: "/api/cofile/paper/checkFileLock",
          method: "post",
          params : {
            fileId: this.bdata.fileId,
            paperBlockId: this.bdata.paperBlockId
          }
        };
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          obj.bdata.blockState = 0;
          obj.searhFileInfo = false;
          if(res.errorCode != null) {
          } else { 
            // 블럭업데이트 전파를위해 필요한 코드 
            // obj.updateFileBlock();
            if(res.result.LockType){
              if(res.result.LockType != "" && res.result.LockType === "NONE"){
                obj.fileBtnDisabledYn = false;
                obj.fileLockYn = false;
              }else{
                obj.fileBtnDisabledYn = true;
                obj.fileLockYn = true;
              }
            }else{
              obj.fileBtnDisabledYn = false;
              obj.fileLockYn = false;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      }
    },
    onMenuToggle(opened){
      if(!opened){
        this.fileLockYn = false;
      }
    }
  },
};
</script>

<!-- 지역스타일 지정 -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeFile.vue